<template>
    <b-card :header="caption" v-if="items.length > 0 || loading">
          <div class="center" v-show="loading"><rotate-square  /></div>

      <b-table 
        v-if="!loading && items.length > 0"
        :hover="true"
        sort-icon-left
        responsive="sm" 
        :items="items" 
        :fields="captions" 
        striped
        :per-page="25">
        <template v-slot:cell(acoes)="data" >
            <div class="btn-group-sm" > 
              <b-button  variant="warning"  @click="edit(data.item)" style="margin-right:10px " title="Editar" >
                  <i class="fa fa-edit fa-lg" style="color: black"></i>
              </b-button>
              <b-button  variant="danger"  @click="clicklixeira(data.item)" title="Excluir">
                  <i class="fa fa-trash" style="color: black"></i>
              </b-button>
            </div>
        </template>
        <template v-slot:cell(cor)="data">
              <input
                v-if="data.item"
                type="color"
                disabled
                :value="data.item.cor"
              />
            </template>
      </b-table>
      <nav>
        <b-pagination-nav
          size="md" 
          :number-of-pages="totalDePaginas" 
          v-model="currentPage" 
          :link-gen="linkGen" 
          >
        </b-pagination-nav>
      </nav>
      <b-modal 
        title="Confirmar exclusão"
        class="modal-danger" 
        v-model="openModalConfirm" 
        @ok="remove" 
        ok-variant="danger">Você confirma a exclusão desse registro? 
      </b-modal>
  
    </b-card>
  </template>
  <script>
  import {RotateSquare} from 'vue-loading-spinner'
  
  export default {
    name: 'grid-balanca',
    components:{
      RotateSquare,
    },  
    inheritAttrs: false,
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      tableData: {
        type: [Array, Function],
        default: () => []
      },
      totalDePaginas: {
        type: Number,
        default: 1
      },
      fields: {
          type: [Array, Object],
          default: () => []
      },
      loading:{
        type: Boolean,
        default: true
      }
    },
    watch: {
      currentPage(){
        this.$emit("paginacao", this.currentPage )
      }
    },
    created() {
      this.currentPage = parseInt(this.$route.params.id)
    },
    data(){
      return {
        currentPage: 1,
        openModalConfirm: false,
        itemExcluir: null
      }
    },
    computed: {
      items() {
        const items =  this.tableData
        return Array.isArray(items) ? items : items()
      },
      captions() { return this.fields }
    },
    methods: {
      getRowCount () {
        return this.items.length
      },
      edit(obj){
        this.$router.push('/configuracao/editar/' + obj.id)
      },
      remove(obj){
        this.openModalConfirm=false
        this.$emit('table-remove', this.itemExcluir)
        this.itemExcluir=null
      },
      linkGen (pageNum) {
        this.$router.push({ path: `/configuracoes/${pageNum}` });
      },
      clicklixeira(item){
        this.openModalConfirm=true
        this.itemExcluir=item
      }
    }
  }
  </script>
  